module.exports = __webpack_public_path__ + "img/warning1.960b1170.svg";